<template>
  <div class="sign-up-message">
    <h1>Create Facebook & Instagram<br />ads in Minutes</h1>
    <h2>Simple social media marketing.</h2>
    <div>
      <el-button
        class="btn-cta tw-my-2"
        type="info"
        @click="$router.push({ path: '/signup' })"
        >CREATE FREE ACCOUNT</el-button
      >
    </div>
    <div>
      <el-button
        class="btn-cta tw-my-2"
        type="secondary"
        @click="$router.push({ path: '/play' })"
        >EXPLORE ADPUZL</el-button
      >
    </div>
    <h3 class="alternate-message">
      Already have an account?
      <router-link :to="{ path: '/login', query: $route.query }"
        >Log in <font-awesome-icon :icon="['far', 'long-arrow-right']"
      /></router-link>
    </h3>
  </div>
</template>

<script>
export default {};
</script>
